const PREFIX = 'document-link-form:';
const PENDING_KEY = `${PREFIX}pending`;
const PENDING_MAX_AGE_MS = 5 * 60 * 1000;

export function saveDocumentLinkFormState(key: string, state: unknown) {
  if (!key) {
    return;
  }
  try {
    const payload = { state, timestamp: Date.now() };
    sessionStorage.setItem(PREFIX + key, JSON.stringify(payload));
  } catch {
    // ignore storage issues
  }
}

export function consumeDocumentLinkFormState<T>(key: string): T | null {
  if (!key) {
    return null;
  }
  const storageKey = PREFIX + key;
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(storageKey);
  } catch {
    raw = null;
  }
  if (!raw) {
    return null;
  }
  try {
    sessionStorage.removeItem(storageKey);
  } catch {
    // ignore
  }
  try {
    const parsed = JSON.parse(raw) as { state: T };
    return parsed?.state ?? null;
  } catch {
    return null;
  }
}

export function peekDocumentLinkFormState<T>(key: string): T | null {
  if (!key) {
    return null;
  }
  const storageKey = PREFIX + key;
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(storageKey);
  } catch {
    raw = null;
  }
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as { state: T };
    return parsed?.state ?? null;
  } catch {
    return null;
  }
}

export function clearDocumentLinkFormState(key: string) {
  if (!key) {
    return;
  }
  try {
    sessionStorage.removeItem(PREFIX + key);
  } catch {
    // ignore
  }
}

export function rememberDocumentLinkPendingKey(key: string) {
  if (!key) {
    return;
  }
  try {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify({ key, timestamp: Date.now() }));
  } catch {
    // ignore storage issues
  }
}

export function getDocumentLinkPendingKey(): string | null {
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(PENDING_KEY);
  } catch {
    raw = null;
  }
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as { key?: string; timestamp?: number };
    if (parsed?.timestamp && Date.now() - parsed.timestamp > PENDING_MAX_AGE_MS) {
      clearDocumentLinkPendingKey();
      return null;
    }
    return parsed?.key ?? null;
  } catch {
    clearDocumentLinkPendingKey();
    return null;
  }
}

export function clearDocumentLinkPendingKey() {
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch {
    // ignore
  }
}
